var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "64px",
    width: "64px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "pt")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-80.0%",
    y: "-80.0%",
    width: "260.0%",
    height: "260.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_portugese_desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  })), /*#__PURE__*/React.createElement("g", {
    id: "portugal",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,10 C0,14.2996094 2.71375,17.9650391 6.52167969,19.3779688 L7.39128906,9.99996094 L6.52167969,0.621992188 C2.71375,2.03496094 0,5.70035156 0,10 Z",
    id: "Path",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,10 C20,4.4771875 15.5228125,0 10,0 C8.77679687,0 7.60503906,0.220039062 6.52167969,0.621992187 L6.52167969,19.3780078 C7.60503906,19.78 8.77679687,20 10,20 C15.5228125,20 20,15.5228125 20,10 Z",
    id: "Path",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFDA44",
    cx: 6.52175781,
    cy: 10,
    r: 3.47824219
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56523438,8.26085937 L4.56523438,10.4347656 C4.56523438,11.5153125 5.44117188,12.3912891 6.52175781,12.3912891 C7.60234375,12.3912891 8.47828125,11.5153516 8.47828125,10.4347656 L8.47828125,8.26085937 L4.56523438,8.26085937 Z",
    id: "Path",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52175781,11.0869531 C6.16214844,11.0869531 5.86957031,10.794375 5.86957031,10.4347656 L5.86957031,9.56523437 L7.17390625,9.56523437 L7.17390625,10.4348047 C7.17390625,10.794375 6.88132813,11.0869531 6.52175781,11.0869531 Z",
    id: "Path",
    fill: "#F0F0F0"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/pt.7206944e.svg";
export { ForwardRef as ReactComponent };